export const KBEditorMenuItem = () => {
  return null;
};
